/* eslint-disable prettier/prettier */
import { useContext } from 'react';

import { ContractContext } from '~components/providers/ContractsProvider';
import { ContractContextTypes, IndexedContracts, NormalContracts } from '~components/providers/types';
import { AllVestaAssets, FarmTypes } from '~config/types';

export const useProtocolContract = <TResult, TAsset extends AllVestaAssets | FarmTypes = AllVestaAssets>(
  contract: ContractContextTypes,
  assetOrFarm?: TAsset,
) => {
  const context = useContext(ContractContext);

  if (!context)
    throw 'Context is undefined. useProtocolContract probably not wrapped in Contract provider...';

  return assetOrFarm
    ? ((context.indexed[contract as keyof IndexedContracts] as any)[assetOrFarm as TAsset] as TResult)
    : (context.normal[contract as keyof NormalContracts] as any as TResult);
};
